export const AppURL = {
    check: 'check',
    setting: 'setting',
    rank: 'setting-rank',
    ui: 'ui',
    profile: 'profile',
    api: 'api',
    keyapi: 'key',
    member: 'member',
    redeem: 'redeem',
    itemRewardBox: 'item-reward-box',
    rate: 'setting-exchange-rate',
    reward: 'setting-rewards',
    coupon: 'setting-coupon',
    point: 'point',
    deduct: 'deduct',
    codeUsed: 'code-used',
    event: 'setting-event',
    gift: 'setting-gift',
    market: 'setting-market',
    secret: 'secret',
    serverip: 'server-ip',
    transaction: 'transaction-information',
    customerlink: 'customer-link',
    dashboard:'dashboard'
};